<div class="questionnaire-title">
    <div *ngIf="title" class="font-large title" [innerHTML]="title"></div>
    <div *ngIf="hint" class="text font-larger" [innerHTML]="hint"></div>
</div>
<div class="answer" [ngClass]="{disabled: disabled}">{{answer}}</div>
